module.exports = __webpack_public_path__ + "static/media/400068_01.32972a4f.png";